import Vue from 'vue'
import Vuetify from 'vuetify'
import VueSuperMethod from 'vue-super-call'
import router from './routes'
import store from './store'
import formatter from './logic/format'

require('./bootstrap')

Vue.use(Vuetify)
Vue.config.productionTip = false
Vue.prototype.$super = VueSuperMethod
window.Vue = Vue

const opts = {}

const vuetify = new Vuetify(opts)

Vue.component('main-container', require('./components/MainContainer').default)
Vue.component('global-footer', require('./components/GlobalFooter').default)

Vue.mixin(formatter)

const app = new Vue({
  el: '#app',
  router,
  store,
  vuetify,
})

export default app
